<template>
    <p>
        <CurlyQuotes>Just some quoted text.</CurlyQuotes>
    </p>

    <p>
        <CurlyQuotes>All <em>work</em> and no <strong>play</strong> make "{{ firstName }}" a dull boy.</CurlyQuotes>
    </p>

    <p class="text-3xl font-bold">
        <CurlyQuotes>Large &amp; bold</CurlyQuotes>
    </p>

    <p class="text-sm italic text-ds-primary-600">
        <CurlyQuotes>Small, italic, colored</CurlyQuotes>
    </p>

    <p>
        The instructions said to enter <CurlyQuotes>For benefit of</CurlyQuotes> in the memo, then confirm the
        <CurlyQuotes>FFC: {{ firstName }} 123456789</CurlyQuotes> reference number.
    </p>
</template>

<script setup lang="ts">
import CurlyQuotes from '@ds/utils/CurlyQuotes.vue';
import { ref } from 'vue';

const firstName = ref('Jack');
</script>

<style lang="scss" scoped>
p {
    @apply mt-4;
}
</style>
